import React from 'react';
import logo from '../../assets/imgs/logo.png';
import AppleStore from '../svgs/AppleStore';
import PlayStore from '../svgs/PlayStore';

const Footer = () => {
  return (
    <footer>
      <div className='upper-sect'>
        <div className='left-sect'>
          <h2>Contact Us</h2>
          <p>
            Benin-Auchi Express Road, Beside Idi Hotel, Ekpoma. Edo State.
            Nigeria
          </p>
          <h3>
            <i className='fas fa-envelope'></i>
            Send a Mail
          </h3>
          <a href='mailto:liontaxi.cooperate@gmail.com'>
            @liontaxi.cooperate@gmail.com
          </a>
        </div>
        <div className='middle-sect'>
          <h2>Quick Links</h2>
          <ul>
            <li>
              <a href='/about'>About Us</a>
            </li>
            <li>
              <a href='/feedback'>Submit Feedback</a>
            </li>
            <li>
              <a href='/drivers'>Drive With Us</a>
            </li>
            <li>
              <a href='/privacy'>Privacy Policy</a>
            </li>
            <li>
              <a href='/admin'>Admin Dashboard</a>
            </li>
          </ul>
        </div>
        <div className='right-sect'>
          <img src={logo} alt='LionTaxi logo' width={110} height={110} />
          <div className='store-buttons2'>
            <a href='https://play.google.com/store/apps/details?id=com.emmalion.liontaxi'>
              <PlayStore />
            </a>
            <a href='https://apps.apple.com/app/liontaxi/id1607504124'>
              <AppleStore />
            </a>
          </div>
        </div>
      </div>
      <div className='copy-sect'>
        <p>&copy; 2021-present Liontaxi. All Rights Reserved</p>
      </div>
    </footer>
  );
};

export default Footer;
